import React from 'react';

import {Avatar} from 'src/components/avatar/avatar';
import {Separator} from 'src/components/separator';
import {UserName} from 'src/components/user-name/user-name';
import {ChangeAuthorController} from 'src/modules/change-author/change-author.controller';
import {AUTHOR_INFO, REVIEWER_INFO} from 'src/modules/event-create/event-create-hovers';
import {
    ContextualLinkController,
} from 'src/modules/event-create/header-block/contextual-link/contextual-link.controller';
import {DueDate} from 'src/modules/event-create/header-block/due-date/due-date';
import {getUsersInfo} from 'src/modules/users-info/services';
import {ChangeRequest} from 'src/openapi/models/ChangeRequest';
import {ChangeRequestContextualLink} from 'src/openapi/models/ChangeRequestContextualLink';
import {useAppSelector} from 'src/store';

import {Dropdown} from '@pb/kit-component-dropdown-v2';
import {Group, Item} from '@pb/kit-component-group';
import {InfoIconButton} from '@pb/kit-component-icon-button';

type Props = {
    changeRequestInfo: ChangeRequest,
    validationHighLight: boolean,
    defaultDueDate: Date | undefined,
    onChangeContextualLinks: (value: ChangeRequestContextualLink[]) => void,
    onChangeDueDate: (date?: Date) => void,
};

export const ChangeRequestMetadata = (props: Props) => {
    const {
        changeRequestInfo,
        validationHighLight,
        defaultDueDate,
        onChangeContextualLinks,
        onChangeDueDate,
    } = props;

    const changeRequestAuthor = useAppSelector(getUsersInfo)?.[changeRequestInfo?.authorEmail ?? ''];
    const changeRequestReviewer = useAppSelector(getUsersInfo)?.[changeRequestInfo?.reviewerEmail ?? ''];

    return (
        <Group direction="v" className="pt-xs">
            <Separator/>
            <Group justify="space-between" gap="xl">
                <Item grow={1} style={{width: '30%'}}>
                    <ContextualLinkController
                        contextualLinks={changeRequestInfo?.contextualLinks}
                        changeRequestId={changeRequestInfo?.id ?? null}
                        validationHighLight={validationHighLight}
                        onChangeLink={onChangeContextualLinks}
                    />
                </Item>
                <Item style={{width: '40%'}}>
                    <Group direction="v">
                        {changeRequestInfo?.authorEmail && changeRequestAuthor ? (
                            <Group justify="start" gap="xl" alignItems="center" style={{minWidth: '0', width: '100%'}}>
                                <Item style={{width: '5.1rem'}}>
                                    <Group gap="xs" alignItems="center">
                                        <strong>Author:</strong>
                                        <Dropdown
                                            hoverEnabled={true}
                                            clickEnabled={false}
                                            maxWidth={500}
                                            anchor={({anchorRef, getAnchorProps}) => (
                                                <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                                            )}>
                                            {AUTHOR_INFO}
                                        </Dropdown>
                                    </Group>
                                </Item>
                                <Group alignItems="center" style={{minWidth: '0'}}>
                                    <Avatar user={changeRequestAuthor}/>
                                    <UserName email={changeRequestInfo.authorEmail}/>
                                </Group>
                                <ChangeAuthorController changeRequest={changeRequestInfo}/>
                            </Group>
                        ) : null}
                        {changeRequestInfo?.reviewerEmail && changeRequestReviewer ? (
                            <Group justify="start" gap="xl" alignItems="center">
                                <Item style={{width: '5.1rem'}}>
                                    <Group gap="xs" alignItems="center">
                                        <strong>Reviewer:</strong>
                                        <Dropdown
                                            hoverEnabled={true}
                                            clickEnabled={false}
                                            maxWidth={500}
                                            anchor={({anchorRef, getAnchorProps}) => (
                                                <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                                            )}>
                                            {REVIEWER_INFO}
                                        </Dropdown>
                                    </Group>
                                </Item>
                                <Group alignItems="center" style={{minWidth: '0'}}>
                                    <Avatar user={changeRequestReviewer}/>
                                    <UserName email={changeRequestInfo.reviewerEmail}/>
                                </Group>
                            </Group>
                        ) : null}
                    </Group>
                </Item>
                <Item style={{minWidth: '20%'}}>
                    <DueDate defaultDueDate={defaultDueDate} onChangeDueDate={onChangeDueDate}/>
                </Item>
            </Group>
        </Group>
    );
};
